//#region src/reward_api_version.ts
let RewardApiVersion = /* @__PURE__ */ function(RewardApiVersion) {
	RewardApiVersion["V1"] = "V1";
	RewardApiVersion["V2"] = "V2";
	return RewardApiVersion;
}({});
//#endregion
export { RewardApiVersion };

//# sourceMappingURL=reward_api_version.js.map